export default "<div class=\"query-suggestions\">\n    <p>{{query-suggestions querySuggestions}}</p>\n</div>";